import { Tooltip } from '@material-ui/core';
import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import { colors, INFO_BTN, INSTRUCTIONS_TOOLTIP } from '../constants/StyleConstants';
import { CONNECTION_RULES, GRAPH_CONNECTION_RULES, INSTRUCTIONS_ARIA_LABEL } from '../constants/AgenticTextConstants';

const Instructions = () => {
  return (
    <Tooltip
      title={
        <div>
          <h4 style={INSTRUCTIONS_TOOLTIP.tooltipTitle}>{GRAPH_CONNECTION_RULES}</h4>
          <ul style={INSTRUCTIONS_TOOLTIP.list}>
            {CONNECTION_RULES.map((rule, index) => (
              <li key={index} style={INSTRUCTIONS_TOOLTIP.listItem}>
                {rule}
              </li>
            ))}
          </ul>
        </div>
      }
      componentsProps={{
        tooltip: {
          sx: INSTRUCTIONS_TOOLTIP.tooltip
        }
      }}
      enterDelay={200}
      leaveDelay={200}
    >
      <InfoIcon style={INFO_BTN} color={colors.WHITE} aria-label={INSTRUCTIONS_ARIA_LABEL} />
    </Tooltip>
  );
};

export default Instructions;
